import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useAuthContext } from 'src/auth/useAuthContext';
import { brandConfig } from 'src/config';
import useResponsive from 'src/hooks/useResponsive';
import { useGetRTKQOwnerProfileQuery } from 'src/redux/rtkQuery/apiSlice';
import * as Yup from 'yup';
import FormProvider from '../hook-form';
import RHFNumberLine from '../hook-form/RHFNumberLine';

const tooltip = {
  0: 'Not likely at all',
  5: 'Neutral',
  10: 'Extremely likely'
};

const defaultValues = { net_promoter_score: null };

const netPromoterFormValidation = Yup.object().shape({
  net_promoter_score: Yup.number().required('Please select a score')
});

const resolver = yupResolver(netPromoterFormValidation);

const question = `On a scale of 0 to 10, how likely are you to recommend ${brandConfig.name} to another property owner? Just tap your score below.`;

const NetPromoterScoreForm = ({ onScoreSelected }: { onScoreSelected?: VoidFunction }) => {
  const isMobile = useResponsive('down', 'sm');
  const { user } = useAuthContext();
  const { refetch: refetchOwnerProfile } = useGetRTKQOwnerProfileQuery(undefined);
  const methods = useForm({ resolver, defaultValues, reValidateMode: 'onSubmit' });

  // Only runs when a 0–10 score link is clicked (form submit). Close/X does not submit.
  // Survey app owns updating nps_last_submit_date — portal only refreshes profile cache.
  const onSubmit = methods.handleSubmit(async () => {
    void refetchOwnerProfile();
    methods.reset(defaultValues);
    onScoreSelected?.();
  });

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <div className="space-y-4">
        <h3 className="text-lg font-semibold leading-tight">{question}</h3>
        <RHFNumberLine
          size={isMobile ? 'small' : undefined}
          tooltip={tooltip}
          shouldSubmit
          name="net_promoter_score"
          min={0}
          max={10}
          href={brandConfig.npsSurveyUrl}
          searchParams={{
            subject: brandConfig.pmUUID || 'missing_brand_id',
            respondent: user?.uuid || 'missing_user_uuid',
            respondentType: 'Owner',
            source: 'portal',
            submit: 'true'
          }}
        />
        <div className="flex w-full justify-between gap-4">
          <span className="text-xs text-muted-foreground">Not likely at all</span>
          <span className="text-right text-xs text-muted-foreground">Extremely likely</span>
        </div>
      </div>
    </FormProvider>
  );
};

export default NetPromoterScoreForm;
